import { useContext, useEffect, useState } from "react";
import { useMediaQuery } from "react-responsive";
import { Helmet } from "react-helmet-async";
import { RecruiterHeader } from "../components/Shared/RecruiterHeader";
import { useNavigate, useParams } from "react-router-dom";
import { StyleContext } from "../providers/StyleContextProvider";
import { ReactComponent as HeaderMobile } from "../assets/svg/short-building.svg";
import { ReactComponent as HeaderDesktop } from "../assets/svg/long-bulding.svg";
import { Transition } from "../components/Shared/Transition";
import { ReactComponent as SuccessfullyApplied } from '../assets/svg/successfully-applied.svg';
import { ReactComponent as InvalidApplied } from '../assets/svg/invalid-applied.svg'
import { Footer } from "../components/Shared/Footer";
import { Button } from "../components/Shared/Buttons/Button";
import { ResponseModel } from "../models/ResponseModel";
import useErrorPage from "../hooks/useErrorPage";
import { postRecruiterEmailConfirmation, postRecruiterLogout } from "../services/RecruiterService";
import { ConfirmationLoader } from "../components/Loaders/ConfirmationLoader";
import { AuthContext } from "../providers/AuthContextProvider";
import { LoggedRecruiter } from "../models/LoggedRecruiter";

export const RecruiterEmailConfirmationPage: React.FC = () => {
    const navigate = useNavigate();
    const [success, setSuccess] = useState<boolean>(true);
    const [title, setTitle] = useState<string>("");
    const [description, setDescription] = useState<string>("");
    const authContext = useContext(AuthContext);
    const recruiter: LoggedRecruiter | null = authContext.getLoggedRecruiter();
    const styleContext = useContext(StyleContext);
    const [styles, setStyles] = useState<any>(styleContext.getComponentStyle("recruiterEmailConfirmationPage"));    
    const {id} = useParams()!;
    const [toErrorPage] = useErrorPage();
    const [loading, setLoading] = useState<boolean>(true);
    const isMobile = useMediaQuery({ query: "(max-width: 786px)" }); 

    useEffect(() => {
        setStyles(styleContext.getComponentStyle("recruiterEmailConfirmationPage"));    
    }, [isMobile]);

    useEffect(() => {
        if(recruiter !== null) {        
            localStorage.removeItem("recruiter");
            localStorage.removeItem("token");
            postRecruiterLogout(recruiter!.recruiterId, recruiter!.token);
        } 
        if (id) {
            confirmRecruiterEmail();
        }
    }, []);

    async function confirmRecruiterEmail () {
        const confirmationId = parseInt(id!, 10);
        await postRecruiterEmailConfirmation(confirmationId)
        .then((response: ResponseModel) => {
            setSuccess(response.status);
            setTitle(response.data.title);
            setDescription(response.data.description);
            setLoading(false);
        })
        .catch((error) => {            
            toErrorPage(error);
        });
    }

    return(
        <>
            <Helmet><title>Email Confirmation - Xpressjobs</title></Helmet>
            <RecruiterHeader recruiterLoginEnable={true}/>
            <div style={styles.header}>
                {isMobile ? <HeaderMobile style={styles.header.backgroundSvg}/> : <HeaderDesktop style={styles.header.backgroundSvg}/>}
                <div style={styles.header.heading}>Email Confirmation</div>
            </div>
            <div style={styles.container}>
                {loading ? <ConfirmationLoader/> : 
                <Transition>
                    {success ? <SuccessfullyApplied style={styles.image}/> : <InvalidApplied style={styles.image}/>}
                    <h3 style={{...styles.title, ...styles.title.email}}>{title}</h3> 
                    <div style={styles.description}>{description}</div>
                    <div style={styles.buttonsContainer}>
                        <Button style={styles.button} onClick={() => navigate("/recruiter/account/login")}>LOGIN</Button> 
                        <Button style={{...styles.button, ...styles.button.back}} onClick={() => navigate('/')}>GO BACK TO HOME</Button>
                    </div>
                </Transition>}
            </div>
            <Footer/>
        </>
    )
}